<template>
  <b-modal
    id="create-schedule-type"
    hide-footer
    no-close-on-backdrop
    size="md"
    modal-class="modern-modal"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-calendar-plus mr-2"></i>
        Cadastrar tipo do Agendamento
      </div>
    </template>

    <div class="modal-content-modern">
      <form @submit.prevent="create">
        <div class="form-section">
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-info-circle mr-2"></i>
              Informações Básicas
            </h4>
          </div>
          <div class="section-content">
            <div class="form-group">
              <LabelRequiredField label="Tipo de Agendamento" />
              <div class="input-wrapper">
                <i class="fas fa-folder input-icon"></i>
                <input
                  type="text"
                  v-model="name"
                  class="modern-input"
                  placeholder="Digite o nome do tipo de agendamento"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Errors -->
        <div class="errors-section" v-if="errors.length > 0">
          <ErrorsMessages :errors="errors" />
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <v-btn :disabled="loading" type="submit" class="btn-save-modern">
            <i class="fas fa-save mr-2"></i>
            {{ loading ? "Salvando..." : "Salvar tipo de Agendamento" }}
          </v-btn>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";

import LabelRequiredField from "../Components/LabelRequiredField";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "CreateModal",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],

      name: "",

      loading: false,
    };
  },

  methods: {
    async create() {
      try {
        this.loading = true;

        const { name } = this;

        let params = {
          name,
        };

        const response = await api.post("/schedule-type", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create-schedule-type");

          this.resetForm();

          toast(message, "success");

          this.$emit("create");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    resetForm() {
      this.errors = [];

      this.name = "";
    },

    // Verificar
    closeSelect() {
      this.$refs.residentSelect.blur();
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

.form-section {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  transition: all 0.3s ease;
}

.form-section:hover {
  border-color: #cbd5e1;
}

.section-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
  font-size: 14px;
}

.section-content {
  padding: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #6b7280;
  font-size: 14px;
  z-index: 1;
}

.modern-input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  color: #1e293b;
}

.modern-input:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
  outline: none;
}

.modern-input::placeholder {
  color: #9ca3af;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Errors Section */
.errors-section {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
  margin-top: 24px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-content-modern {
    padding: 0;
  }
  .form-actions {
    padding-top: 20px;
  }
  .btn-save-modern {
    width: 100% !important;
    padding: 12px 24px !important;
  }
}

@media (max-width: 480px) {
  .modal-title-modern {
    font-size: 18px;
    flex-direction: column;
    gap: 4px;
  }
  .modern-input {
    padding: 10px 14px 10px 36px;
    font-size: 13px;
  }
  .input-icon {
    left: 10px;
    font-size: 13px;
  }
}

/* Modal Header Override */
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
  padding: 20px 24px !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}

.modern-modal >>> .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important;
}
</style>